import styled from "styled-components";

export const ParallelAttributeText = styled.span`
    grid-area: label;
    transition: opacity 0.2s ease;
`;

export const ParallelAttributeActionText = styled.span`
    grid-area: label;
    opacity: 0;
    transition: opacity 0.2s ease;
`;

/* Both labels share one grid cell so the pill never resizes when hover swaps them */
export const ParallelAttributeLabels = styled.span`
    display: grid;
    grid-template-areas: 'label';
    justify-items: center;
`;

export const ParallelAttributeContainer = styled.h4`
    align-items: center;
    box-sizing: border-box;
    cursor: ${(props) => props.$hasAction ? 'pointer' : 'default'};
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    overflow: hidden;
    white-space: nowrap;
    transition: width 0.4s ease, padding 0.4s ease, background-color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;
    /* Inactive state: 20x20, no text visible (unless alwaysExpanded) */
    width: ${(props) => props.$alwaysExpanded ? 'fit-content' : '24px'};
    height: ${(props) => props.$alwaysExpanded ? 'auto' : '24px'};
    min-height: ${(props) => props.$alwaysExpanded ? '24px' : 'auto'};
    padding: ${(props) => props.$alwaysExpanded ? '2px 8px' : '0'};

    background-color: ${(props) => {
        if (props.$color) {
            const hex = props.$color.replace('#', '');
            const bigint = parseInt(hex, 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;
            return `rgba(${r}, ${g}, ${b}, 0.2)`;
        }
        return 'rgba(255, 255, 255, 0.2)';
    }};
    border: ${(props) => {
        if (!props.$color) return 'solid 1px #FFFFFF';
        const hex = props.$color.replace('#', '').toUpperCase();
        const isWhite = hex === 'FFFFFF' || hex === 'FFF';
        return isWhite ? 'solid 1px rgba(255, 255, 255, 0.6)' : `solid 1px ${props.$color}`;
    }};
    border-radius: 100px;
    box-shadow: inset 0 0 4px rgba(255, 255, 255, 0.35);
    color: #FFFFFF;
    font-size: 12px;
    font-weight: 500;

    ${ParallelAttributeText} {
        opacity: ${(props) => props.$alwaysExpanded ? '1' : '0'};
    }

    /* Hover state: expand and display text (skip layout changes when alwaysExpanded) */
    &:hover {
        ${(props) => !props.$alwaysExpanded && `
            width: fit-content;
            height: auto;
            min-height: 20px;
            padding: 4px 16px;
        `}
        ${(props) => props.$hasAction && `
            opacity: 0.75;
        `}
    }

    /* Hovering an actionable pill swaps its label for the action label */
    &:hover ${ParallelAttributeText} {
        opacity: ${(props) => props.$hasAction ? '0' : '1'};
    }

    &:hover ${ParallelAttributeActionText} {
        opacity: 1;
    }

    &:focus-visible {
        outline: 1px solid rgba(255, 255, 255, 0.8);
        outline-offset: 1px;
    }

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
`;
